/*
 * @Author: wangweixin
 * @Date: 2018-01-18 17:51:18
 * @Last Modified by: wangweixin
 * @Last Modified time: 2020-06-29 11:41:26
 */
import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef
} from 'react';
import classNames from 'classnames';
import { useControlledInputs } from '../../common/hooks';

function Textarea(props, ref) {
  const {
    defaultValue = '',
    onChange,
    max,
    radius,
    className,
    hasError: error,
    disabled,
    style,
    mini,
    placeholder,
    ...others
  } = props;
  const [focus, setFocus] = useState(false);
  const { value, handleChange } = useControlledInputs({
    defaultValue,
    onChange,
    mapDefaultToValue: v => v,
    mapValuetoValue: e => e.target.innerText
  });
  const inputEl = useRef(null);

  useEffect(() => {
    inputEl && !focus && (inputEl.current.innerText = defaultValue);
  }, [defaultValue]);

  useImperativeHandle(ref, () => ({
    focus: () => inputEl.current?.focus(),
    blur: () => inputEl.current?.blur()
  }));

  const classes = classNames('input', 'textarea', 'textarea-wrap', className, {
    error,
    'is-disabled': disabled,
    focus,
    mini,
    radius
  });
  return (
    <div className={classes} {...others}>
      <div
        style={style}
        contentEditable={disabled ? 'false' : 'true'}
        className="textarea-content"
        onInput={handleChange}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        placeholder={placeholder}
        ref={inputEl}
      />
      <span className="max">
        <i>{value?.length}</i>/{max}
      </span>
    </div>
  );
}

export default forwardRef(Textarea);
